<template>
    <modal :closeable="closeable" :max-width="maxWidth" :max-height="maxHeight" :show="show" @close="close">
        <div class="relative">

            <div v-html="currentImage" v-touch:swipe.left="toNextImage" v-touch:swipe.right="toPrevImage" v-touch:swipe.up="close"></div>

            <div class="absolute top-0 right-0">
                <button class="mt-3 mr-3 inline-flex items-center px-2.5 py-1.5 shadow-sm text-sm font-bold rounded-md text-gray-600 bg-white focus:outline-none transition duration-150 ease-in-out" type="button" @click="close">
                    Close
                </button>
            </div>

        </div>

        <!-- Arrow Key Events -->
        <Keypress key-event="keyup" :key-code="38" @success="close" />
        <Keypress key-event="keyup" :key-code="37" @success="toPrevImage" />
        <Keypress key-event="keyup" :key-code="39" @success="toNextImage" />

    </modal>
</template>

<script>
import Modal from '@/Jetstream/Modal';
import Keypress from 'vue-keypress';

export default {
    components: {
        Modal,
        Keypress
    },

    props: {
        show: {
            default: false
        },
        maxWidth: {
            default: '5xl'
        },
        maxHeight: {
            default: null
        },
        closeable: {
            default: true
        },
        images: {
            type: Array,
            default: []
        },
        image: {
            type: String,
            default: null
        }
    },

    computed: {
        currentIndex() {
            return this.images.findIndex(image => image === this.image);
        },
        currentImage() {
            return this.image;
        },
        prevImage() {
            return this.images[this.currentIndex === 0 ? this.images.length - 1 : this.currentIndex - 1];
        },
        nextImage() {
            return this.images[this.currentIndex === this.images.length - 1 ? 0 : this.currentIndex + 1]
        },
        hasTitle() {
            return !!this.$slots.title;
        },
        hasFooter() {
            return !!this.$slots.footer;
        }
    },

    methods: {

        toPrevImage(){
            if(!this.show) return null;
            this.$emit('update:image', this.prevImage);
        },

        toNextImage(){
            if(!this.show) return null;
            this.$emit('update:image', this.nextImage);
        },

        close() {
            if(!this.show) return null;
            this.$emit('close');
        }

    }
}
</script>
